<template>
  <CardContainer>
    <v-skeleton-loader type="list-item" class="device-card">
    </v-skeleton-loader>
    <v-skeleton-loader type="list-item" class="device-card">
    </v-skeleton-loader>
    <v-skeleton-loader type="list-item" class="device-card">
    </v-skeleton-loader>
    <v-skeleton-loader type="list-item" class="device-card">
    </v-skeleton-loader>
  </CardContainer>
</template>

<script>
import CardContainer from '../Base/CardContainer.vue'

export default {
  name: 'CardItemSkeleton',
  components: {
    CardContainer,
  },
}
</script>

<style scoped lang="scss">
$first-card-width: 24px;
$first-card-height: 24px;
$first-card-mb: 16px;

$second-card-width: 52px;
$second-card-height: 28px;

$third-card-width: 100px;
$third-card-height: 18px;

$fourth-card-width: 72px;
$fourth-card-height: 18px;

.device-card {
  border-radius: 8px;
  margin-bottom: 4px;

  ::v-deep > * {
    padding: 0;
  }

  ::v-deep .v-skeleton-loader__list-item {
    border-radius: 8px;
  }

  ::v-deep .v-skeleton-loader__list-item {
    .v-skeleton-loader__text {
      background-color: varFigma(neutral-95-lightest);
    }
  }

  &:nth-child(1) {
    width: $first-card-width;
    margin-bottom: $first-card-mb;

    ::v-deep .v-skeleton-loader__list-item {
      width: $first-card-width;
      height: $first-card-height;

      .v-skeleton-loader__text {
        height: $first-card-height;
      }
    }
  }

  &:nth-child(2) {
    width: $second-card-width;

    ::v-deep .v-skeleton-loader__list-item {
      width: $second-card-width;
      height: $second-card-height;

      .v-skeleton-loader__text {
        height: $second-card-height;
      }
    }
  }

  &:nth-child(3) {
    width: $third-card-width;

    ::v-deep .v-skeleton-loader__list-item {
      width: $third-card-width;
      height: $third-card-height;

      .v-skeleton-loader__text {
        height: $third-card-height;
      }
    }
  }

  &:nth-child(4) {
    width: $fourth-card-width;
    margin-bottom: 0px;

    ::v-deep .v-skeleton-loader__list-item {
      width: $fourth-card-width;
      height: $fourth-card-height;

      .v-skeleton-loader__text {
        height: $fourth-card-height;
      }
    }
  }
}
</style>
